import { render, staticRenderFns } from "./interests.vue?vue&type=template&id=c9d9c92a&scoped=true&"
import script from "./interests.vue?vue&type=script&lang=js&"
export * from "./interests.vue?vue&type=script&lang=js&"
import style0 from "./interests.vue?vue&type=style&index=0&id=c9d9c92a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d9c92a",
  null
  
)

export default component.exports